import React from 'react';
import styled from 'styled-components';
import { AppColors } from 'helpers';
import { Div, HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { TextDisplay } from 'vendor-deprecated/Text';
import { useTranslationText } from 'locale';
import { useAppSetting } from 'helpers/useAppSetting';
import { ContentLoading } from 'vendor-deprecated/Loading';

const Button = styled.button<{ disabled?: boolean }>`
  position: relative;
  margin-top: 15px;
  font-weight: bold;
  font-size: 15px;
  width: 100%;
  border-style: none;
  border-radius: 4px;
  padding: 15px;
  color: ${AppColors.WHITE};
  background: ${AppColors.GRASSY_GREEN};
  outline: none;
  cursor: ${(props) => (props.disabled ? 'default;' : 'pointer;')}
  opacity:${(props) => (props.disabled ? '0.7;' : '1;')}
  &:hover {
    opacity: 0.7;
  }
`;

const i18key = 'public.courseDetails.card';

export const FreeButton = React.memo(
  (props: { addCourseFreeLoading?: boolean; disabled?: boolean; onAddToMyCourse: () => void }) => {
    const { appLayout } = useAppSetting();
    const { translation } = useTranslationText();
    return (
      <VerticalView fullWidth alignContent={'center'}>
        <Button
          disabled={props.disabled || props.addCourseFreeLoading}
          onClick={(e) => {
            if (props.addCourseFreeLoading) {
              return;
            }
            e.preventDefault();
            props.onAddToMyCourse();
          }}
        >
          <HorizontalView height={'100%'} alignContent={'center'}>
            {props.addCourseFreeLoading && (
              <Div marginRight={'5px'}>
                <ContentLoading size={'20px'} color={AppColors.WHITE} loading />
              </Div>
            )}

            <TextDisplay marginLeft={'10px'}>{translation(`${i18key}.addToMyCourse`)}</TextDisplay>
          </HorizontalView>
        </Button>

        <Div marginTop={'10px'}>
          <TextDisplay size={'11px'} color={appLayout.isMobile ? AppColors.WHITE : AppColors.GRAY_DARK}>
            {translation(`${i18key}.freeMessage`)}
          </TextDisplay>
        </Div>
      </VerticalView>
    );
  },
);
